var Voucher = /** @class */ (function () {
    function Voucher(props) {
        Object.assign(this, props);
        if (props.lines) {
            this.lines = props.lines.map(function (line) { return new VoucherLine(line); });
        }
        if (props.boxPayments && typeof props.boxPayments === 'string') {
            this.boxPayments = JSON.parse(props.boxPayments);
        }
        else {
            this.boxPayments = props.boxPayments;
        }
        if (props.affiliate_company && typeof props.affiliate_company === 'string') {
            this.affiliate_company = JSON.parse(props.affiliate_company);
        }
        else {
            this.affiliate_company = props.affiliate_company;
        }
    }
    return Voucher;
}());
export default Voucher;
var VoucherLine = /** @class */ (function () {
    function VoucherLine(props) {
        Object.assign(this, props);
    }
    return VoucherLine;
}());
export { VoucherLine };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Vouchers/Model.ts
// module id = 111
// module chunks = 0